import { injectBaseConstantMethods } from "./BaseConstants"

const InventoryReqItemStatus = {
    Pending: "Pending",
    All_Delivered: "AllDelivered",
    Partial_Delivered: "PartialDelivered",
    Substitutes: "Substitutes",
    Cancelled: "Cancelled",
}

const displayTextKeys = {
    [InventoryReqItemStatus.Pending]: "Pending",
    [InventoryReqItemStatus.All_Delivered]: "All Delivered",
    [InventoryReqItemStatus.Partial_Delivered]: "Partial Delivered",
    [InventoryReqItemStatus.Substitutes]: "Substitutes",
    [InventoryReqItemStatus.Cancelled]: "Cancelled",
}

const labelClass = {
    [InventoryReqItemStatus.Pending]: "fm-bg-light-red",
    [InventoryReqItemStatus.All_Delivered]: "fm-bg-light-green",
    [InventoryReqItemStatus.Partial_Delivered]: "fm-bg-light-yellow",
    [InventoryReqItemStatus.Substitutes]: "fm-bg-light-yellow",
    [InventoryReqItemStatus.Cancelled]: "fm-bg-light-red",
}

export default injectBaseConstantMethods(
    InventoryReqItemStatus,
    displayTextKeys,
    labelClass
)
